export const defaultSessionDomainState = {
    languageTag: undefined,
    isBrowserSupported: undefined,
    hasUnsupportedBrowserWarningBeenSeen: false
};
